export default {
  scheduled: 'Automático',
  manual: 'Manual',
};
